module.exports = __webpack_public_path__ + "static/bg_social_medias-8367f1a20c209779d935873e678f075e.webp";